import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { translate } from '@haldor/ui';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
/*import MatrixForm from './MatrixForm/MatrixForm'; **/

import MatrixForm from "./Form/MatrixForm";
/* Compontent for creating Matrixes */

var TestPage = /*#__PURE__*/function (_Component) {
  _inherits(TestPage, _Component);

  var _super = _createSuper(TestPage);

  function TestPage(props) {
    var _this;

    _classCallCheck(this, TestPage);

    _this = _super.call(this, props);
    _this.state = {
      matrix: null
    };
    return _this;
  }

  _createClass(TestPage, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      var _this2 = this;

      if (this.props.match.params != null && this.props.match.params.matrixId != null) {
        var matrix = this.props.matrixes.find(function (t) {
          return t.id == _this2.props.match.params.matrixId;
        });
        this.setState({
          matrix: {
            id: matrix.id,
            title: matrix.title,
            matrixBlocks: matrix.matrixBlocks
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "container"
      }, /*#__PURE__*/React.createElement(Expandable, {
        title: this.props.translate("matrix")
      }, /*#__PURE__*/React.createElement(MatrixForm, {
        matrix: this.state.matrix,
        Type: ASSESSMENT_MATRIX
        /*onMatrixFormUpdate={this.onMatrixFormUpdate.bind(this)}**/
        ,
        editView: this.props.initialValues != null
      })), /*#__PURE__*/React.createElement(Link, {
        to: "/matrixList"
      }, "Matrix List"));
    }
  }]);

  return TestPage;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    matrixes: state.Matrix.matrixList
  };
}

export default connect(mapStateToProps, {})(TestPage);